import { AuthApi } from "@/api/config/AuthApi";
import { ConstantsApi } from "@/api/config/ConstantsApi";
import { DefinicoesGeraisApi } from "@/api/config/DefinicoesGeraisApi";
import { DadosComercianteApi } from "@/api/config/DadosComercianteApi";
import { IntegracaoApi } from "@/api/config/IntegracaoApi";
import { ChavesFacturacaoElectronicaApi } from "@/api/config/ChavesFacturacaoElectronicaApi";
import { CaixasApi } from "@/api/config/CaixasApi";
import { ContasBancariasApi } from "@/api/config/ContasBancariasApi";
import { EstabelecimentosApi } from "@/api/config/EstabelecimentosApi";
import { MesasApi } from "@/api/config/MesasApi";
import { UtilizadoresApi } from "@/api/config/UtilizadoresApi";
import { NotificacaoApi } from "@/api/config/NotificacaoApi";

import { ArtigosApi } from "@/api/facturacao/ArtigosApi";
import { AuxiliarApi } from "@/api/facturacao/AuxiliarApi";
import { CategoriaApi } from "@/api/facturacao/CategoriaApi";
import { ClienteApi } from "@/api/facturacao/ClienteApi";
import { FornecedorApi } from "@/api/facturacao/FornecedorApi";
import { DocumentosApi } from "@/api/facturacao/DocumentosApi";
import { RelatorioApi } from "@/api/facturacao/RelatorioApi";

import { LicencaApi } from "@/api/licenca/LicencaApi";
import { StockApi } from "@/api/stock/StockApi";
import { TesourariaApi } from "@/api/tesouraria/TesourariaApi";
import { CaixaPosApi } from "@/api/pos/CaixaPosApi";
import { TerminalPosApi } from "@/api/pos/TerminalPosApi";

export const authApi = new AuthApi();
export const constantsApi = new ConstantsApi();
export const definicoesGeraisApi = new DefinicoesGeraisApi();
export const dadosComercianteApi = new DadosComercianteApi();
export const integracaoApi = new IntegracaoApi();
export const chavesFacturacaoElectronicaApi =
  new ChavesFacturacaoElectronicaApi();
export const caixasApi = new CaixasApi();
export const contasBancariasApi = new ContasBancariasApi();
export const estabelecimentosApi = new EstabelecimentosApi();
export const mesasApi = new MesasApi();
export const utilizadoresApi = new UtilizadoresApi();
export const notificacaoApi = new NotificacaoApi();

export const artigosApi = new ArtigosApi();
export const auxiliarApi = new AuxiliarApi();
export const categoriaApi = new CategoriaApi();
export const clienteApi = new ClienteApi();
export const fornecedorApi = new FornecedorApi();
export const documentosApi = new DocumentosApi();
export const relatorioApi = new RelatorioApi();

export const licencaApi = new LicencaApi();
export const stockApi = new StockApi();
export const tesourariaApi = new TesourariaApi();
export const caixaPosApi = new CaixaPosApi();
export const terminalPosApi = new TerminalPosApi();
